import { ClientId, ScopesByClientIds } from './constants';

export const getScopesByClientId = (clientId: ClientId): string[] | undefined => {
  return ScopesByClientIds[clientId] || undefined;
};

export const getThirdPartyScopesByClientId = (clientId: ClientId): string[] | undefined => {
  return ScopesByClientIds[clientId] || ScopesByClientIds.default_third_party_client || undefined;
};
